




















import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import TimeZoneCard from "@/components/form/TimeZoneCard.vue";
import CommonInputModal from "@/components/common/CommonInputModal.vue";
import {get} from "@/context/context";
import {TimeZoneService} from "@/services/TimeZoneService";
import {TimeZone} from "@/models/TimeZone";

@Component({
  components: {
    TimeZoneCard,
    CommonInputModal
  },
})
export default class TimeZoneInput extends Vue {
  private timeZoneService: TimeZoneService = get('timeZoneService');
  private list: Array<TimeZone> = [];
  private zoneName: string = '';
  private zoneId: number|null = null;

  @Prop()
  private value!: string;

  @Prop()
  private label?: string;

  @Prop()
  private name?: string;

  @Prop()
  private rules?: Array<any>;

  @Prop({default: ''})
  private errorMessage!: string;

  @Prop({default: false})
  private disabled!: boolean;

  @Prop({default: false})
  private dark!: boolean;

  @Prop()
  private color?: string;

  @Prop({default: false})
  private dense?: boolean;

  @Prop({default: true})
  private rounded?: boolean;

  @Watch('value')
  watchPropValue() {
    this.inputData = this.value;
  }

  private isShow: boolean = false
  private inputData: string = '';

  private async created() {
    this.list = await this.timeZoneService.getList();

    let offset = new Date().getTimezoneOffset();
    let whole = (Math.trunc(offset/60)) * (-1);
    let remainder = ((offset/60) * (-1)) - whole;
    let value = (whole > 0 ? '+' : '-') + (Math.abs(whole) < 10 ?
        '0'+(Math.abs(whole)).toString()
        : (Math.abs(whole)).toString()) +':'+ (Math.abs(remainder) > 0 ? '30' : '00');
    let zoneName = new Intl.DateTimeFormat().resolvedOptions().timeZone

    let result = this.list.find(element => element.value === value && element.code === zoneName);
    if (result) {
      this.inputData = result.name;
      this.zoneName = result.name;
      this.zoneId= result.id;
    }
  }

  private handleOnChange() {
    this.$emit('input', this.zoneName);
    this.$emit('change', this.zoneName);
    this.$emit('changeId', this.zoneId);
  }

  private handleTimeZone(timeZone?:TimeZone) {
    if (!timeZone) {
      this.isShow = false;
    } else {
      this.inputData = timeZone.name;
      this.zoneName = timeZone.name;
      this.zoneId= timeZone.id;
      this.isShow = false
    }
  }

  private changeShow(show:boolean) {
    this.isShow = show;
  }
}
